import { IBusinessAreaFields } from "../@types/contentful";
import { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";

export const replaceFilterNames = (
  items: RefinementListItem[],
  categories: IBusinessAreaFields[]
) => {
  const newItems = items
    .map((algoliaItem: any) => {
      const contentfulItem = categories?.find(
        (item: IBusinessAreaFields) =>
          item?.tag?.toLowerCase() === algoliaItem.label.toLowerCase()
      );
      if (!contentfulItem) {
        console.log("error", algoliaItem);
        return null;
      }
      algoliaItem.label = contentfulItem.label;

      return algoliaItem;
    })
    .filter((el: any) => el !== null);

  return newItems;
};